export default __webpack_public_path__ + "static/profile-224efb237d847361aa7403da934e322b.png";